import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GrupoSocioDto } from 'src/app/shared/models/caso/grupo/grupo-socio/grupo-socio-dto.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GrupoSocioService {
  constructor(private http: HttpClient) { }

  findAll(idGrupo: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/grupos/${idGrupo}/socios`);
  }
  findAllAvailables(idGrupo: number): Observable<any> {
    return this.http.get(`${environment.apiSecurityUrl}api/v1/grupos/${idGrupo}/socios/disponibles`);
  }

  persist(idGrupo: number, dto: GrupoSocioDto): Observable<any> {
    return this.http.post(`${environment.apiSecurityUrl}api/v1/grupos/${idGrupo}/socios`, dto);
  }

  delete(idGrupo: number, id: number): Observable<any> {
    return this.http.delete(`${environment.apiSecurityUrl}api/v1/grupos/${idGrupo}/socios/${id}`);
  }
}
